export enum SearchStyle {
  None = '',
  Input = 'input'
}
